import { YNSProvider } from "./providers/yns";
import type { CommerceConfig } from "./types";

export function Commerce(config: CommerceConfig = {}): YNSProvider {
	return new YNSProvider(config);
}
